import { Link } from 'react-router-dom';
import ArticleLayout from '@/pages/article/components/ArticleLayout';
import Footer from '@/pages/home/components/Footer';

export default function BasetaoProductFinds() {
  return (
    <>
      <ArticleLayout title="Best Basetao Product Finds 2026: Hidden Gems & Community Favorites" subtitle="Curated collection of top-rated product discoveries sourced from Basetao spreadsheets, community reviews, and QC-verified hauls across every major category." tag="Products">
        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Community-Favorite Basetao Finds</h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            The <strong className="text-foreground-900">Basetao spreadsheet</strong> community has uncovered thousands of high-quality product links across sneakers, streetwear, accessories, and home goods. The best finds consistently deliver excellent quality-to-price ratios &mdash; items where the materials, construction, and accuracy justify every dollar spent.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            Top categories trending in 2026 include premium sneaker batches, heavyweight hoodies, minimalist accessories, and techwear pieces. Each discovery shared in the community typically includes QC photos, sizing notes, and direct seller comparisons. Browse the <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline">Basetao Spreadsheet homepage</Link> for the full category breakdown.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Top Picks This Season</h2>
          <div className="space-y-4">
            {[
              { cat: 'Sneakers', find: 'Premium batch running shoes with accurate materials and excellent comfort ratings.' },
              { cat: 'Hoodies', find: 'Heavyweight 800g+ cotton hoodies praised for fabric quality and construction.' },
              { cat: 'Bags', find: 'Minimalist backpacks and totes with durable hardware and clean silhouettes.' },
              { cat: 'Accessories', find: 'Watches, wallets, and jewelry pieces with strong QC feedback.' },
            ].map((f) => (
              <div key={f.cat} className="flex gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70">
                <span className="text-sm font-semibold text-accent-600 min-w-[80px]">{f.cat}</span>
                <p className="text-sm text-foreground-700">{f.find}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <div className="bg-primary-50/50 border border-primary-200/50 rounded-lg p-6 md:p-8 text-center">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Browse All Categories</h2>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">Back to BasetaoSheet Home</Link>
          </div>
        </section>
      </ArticleLayout>
      <Footer />
    </>
  );
}